import React from 'react';
import { useState, useEffect } from 'react';
import { ContextMenu, MenuItem, ContextMenuTrigger, showMenu, hideMenu } from "react-contextmenu";
// import "./TableNoteBook.css";



export default function BoxViewNotebook(props) {
    const { sampleProjects: initialSampleProjects = [] } = props;

    const [sampleProjects, setSampleProjects] = useState(initialSampleProjects);

    const [openedContextMenuId, setOpenedContextMenuId] = useState("");

    // Keep internal state in sync with incoming props (class constructor only set initial values;
    // these effects will update state when parent props change).
    useEffect(() => {
        setSampleProjects(props.sampleProjects || []);
    }, [props.sampleProjects]);



    const handleCreate = () => {
        if (typeof props.handleCreateNoteBook === 'function') {
            props.handleCreateNoteBook();
        }
    };
    const handleOnOpenedContextMenuClick = (_id) => {
        setOpenedContextMenuId(_id)
    }

    return (
        <section className="notebook-genai-grid" aria-label="My projects">
            {/* Create New card */}
            <article
                className="notebook-genai-createCard"
                tabIndex={0}
                aria-label="Create new notebook"
                onClick={handleCreate}
            >
                <div className="notebook-genai-createInner">
                    <div className="notebook-genai-circle">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path
                                d="M7.99972 3.33334V12.6667M3.33322 8.00001H12.6662"
                                stroke="#F3F3F3"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    </div>
                    <div className="notebook-genai-createText">Create New Notebook</div>
                </div>
            </article>

            {/* Project cards */}
            {sampleProjects.map((item, index) => {
                // if item.title exists and length > 0, use BoxViewforItem like original
                if (item && item.title && item.title.length > 0) {
                    return (
                        // Keep same props passed to BoxViewforItem as original class component
                        <BoxViewforItem
                            key={index}
                            index={index}
                            item={item}
                            handleViewExisting={props.handleViewExisting}
                            handleDeleteExisting={props.handleDeleteExisting}
                            handleOnOpenedContextMenuClick={handleOnOpenedContextMenuClick}
                            openedContextMenuId={openedContextMenuId}
                        />
                    );
                }

                // Untitled / fallback card (keeps original markup)
                return (
                    <article
                        key={item.id || `untitled-${index}`}
                        className="notebook-genai-createCard"
                        tabIndex={0}
                        aria-label={`${item.title}, ${item.date}`}
                    >
                        <div className="notebook-genai-cardTop">
                            <div className="notebook-genai-cardAccentMarker" aria-hidden="true">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                    <path
                                        d="M7.99971 8.66666C8.36789 8.66666 8.66636 8.36818 8.66636 7.99999C8.66636 7.6318 8.36789 7.33332 7.99971 7.33332C7.63154 7.33332 7.33307 7.6318 7.33307 7.99999C7.33307 8.36818 7.63154 8.66666 7.99971 8.66666Z"
                                        stroke="#81766F"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path
                                        d="M7.99971 3.99999C8.36789 3.99999 8.66636 3.70151 8.66636 3.33332C8.66636 2.96513 8.36789 2.66666 7.99971 2.66666C7.63154 2.66666 7.33307 2.96513 7.33307 3.33332C7.33307 3.70151 7.63154 3.99999 7.99971 3.99999Z"
                                        stroke="#81766F"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path
                                        d="M7.99971 13.3333C8.36789 13.3333 8.66636 13.0348 8.66636 12.6667C8.66636 12.2985 8.36789 12 7.99971 12C7.63154 12 7.33307 12.2985 7.33307 12.6667C7.33307 13.0348 7.63154 13.3333 7.99971 13.3333Z"
                                        stroke="#81766F"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                            </div>
                        </div>

                        <div className="notebook-genai-cardBody">
                            <div className="notebook-genai-cardTitle" title={item.title}>{item.title}</div>
                            <div className="notebook-genai-cardMeta">
                                <span>{item.date}</span>
                            </div>
                        </div>
                    </article>
                );
            })}
            {/* Untitled cards */}
        </section>
    );
}


function BoxViewforItem(props) {


    useEffect(() => {
        if (props.openedContextMenuId !== `NL-${props.item.id}`) {
            hideMenu({
                id: `NL-${props.item.id}`
            });
        }
    }, [props.openedContextMenuId, props.item.id]);

    const handleLeftMouseClick = (e, _id) => {
        e.stopPropagation();
        const x = e.clientX;
        const y = e.clientY;
        props.handleOnOpenedContextMenuClick(_id);
        showMenu({
            position: { x, y },
            id: _id
        });

    }
    const onContextMenuHide = () => {
        props.handleOnOpenedContextMenuClick("");
    }


    return (
        <article
            key={props.index}
            className='titled-card'
            tabIndex={0}
            aria-label={`${props.item.title}, ${props.item.date}`}
            onClick={() => props.handleViewExisting(props.item.id, props.item.title)}
        >
            <div className='notebook-genai-cardTop'>
                <div className='notebook-genai-cardAccentMarker' aria-hidden="true" >
                    <ContextMenuTrigger id={`NL-${props.item.id}`}>
                        <button className='notebook-genai-card-view-more' title='More Option'
                            onClick={e => { handleLeftMouseClick(e, `NL-${props.item.id}`) }}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <path d="M7.99971 8.66666C8.36789 8.66666 8.66636 8.36818 8.66636 7.99999C8.66636 7.6318 8.36789 7.33332 7.99971 7.33332C7.63154 7.33332 7.33307 7.6318 7.33307 7.99999C7.33307 8.36818 7.63154 8.66666 7.99971 8.66666Z" stroke="#81766F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M7.99971 3.99999C8.36789 3.99999 8.66636 3.70151 8.66636 3.33332C8.66636 2.96513 8.36789 2.66666 7.99971 2.66666C7.63154 2.66666 7.33307 2.96513 7.33307 3.33332C7.33307 3.70151 7.63154 3.99999 7.99971 3.99999Z" stroke="#81766F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M7.99971 13.3333C8.36789 13.3333 8.66636 13.0348 8.66636 12.6667C8.66636 12.2985 8.36789 12 7.99971 12C7.63154 12 7.33307 12.2985 7.33307 12.6667C7.33307 13.0348 7.63154 13.3333 7.99971 13.3333Z" stroke="#81766F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </button>
                    </ContextMenuTrigger>
                    <ContextMenu id={`NL-${props.item.id}`} onHide={e => { onContextMenuHide(e) }} className="notebook-genai-item-contextMenu">
                        <MenuItem onClick={e => { e.stopPropagation(); props.handleDeleteExisting(props.item.id) }}>
                            <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="trash" class="svg-inline--fa fa-trash fa-fw " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M177.1 48h93.7c2.7 0 5.2 1.3 6.7 3.6l19 28.4h-145l19-28.4c1.5-2.2 4-3.6 6.7-3.6zM354.2 80L317.5 24.9C307.1 9.4 289.6 0 270.9 0H177.1c-18.7 0-36.2 9.4-46.6 24.9L93.8 80H80.1 32 24C10.7 80 0 90.7 0 104s10.7 24 24 24H35.6L59.6 452.7c2.5 33.4 30.3 59.3 63.8 59.3H324.6c33.5 0 61.3-25.9 63.8-59.3L412.4 128H424c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8H367.9 354.2zm10.1 48L340.5 449.2c-.6 8.4-7.6 14.8-16 14.8H123.4c-8.4 0-15.3-6.5-16-14.8L83.7 128H364.3z"></path></svg>
                            <span>Delete</span>
                        </MenuItem>
                    </ContextMenu>
                </div>
            </div>

            <div className='notebook-genai-cardBody' /*onClick={() => props.handleViewExisting(props.item.id, props.item.title)}*/>
                <div className='notebook-genai-cardTitle' title={props.item.title}>{props.item.title}</div>
                <div className='notebook-genai-cardMeta'>
                    <span>{props.item.date}</span>
                </div>
            </div>
        </article>
    )
}